import { getTheme } from "@/features/branding";
import { store } from "@/store";
import { portfolioExportActions } from "@/store/slices/portfolioExport";
import CheckCircleOutlined from "@ant-design/icons/es/icons/CheckCircleOutlined";
import LoadingOutlined from "@ant-design/icons/es/icons/LoadingOutlined";
import { Badge, Button } from "antd";
import { useMemo } from "react";
import { useActiveSummariesWithProgress } from "../hooks/useActiveSummariesWithProgress";
import { SummaryStatusModal } from "./SummaryStatusModal";
export const SummaryStatus = () => {
  const {
    summaries,
    adaptationSummaries
  } = useActiveSummariesWithProgress();
  const allCompleted = useMemo(() => {
    const all = [...(summaries ?? []), ...(adaptationSummaries ?? [])];
    return all.length > 0 && all.every(s => s.status === "complete");
  }, [summaries, adaptationSummaries]);
  const icon = useMemo(() => {
    if (allCompleted) return <CheckCircleOutlined />;
    return <LoadingOutlined spin />;
  }, [allCompleted]);
  const buttonText = useMemo(() => {
    if (allCompleted) return "Summary generated";
    return "Generating Summary";
  }, [allCompleted]);
  const handleOpen = () => {
    store.dispatch(portfolioExportActions.setSummaryStatusModal({
      isOpen: true
    }));
  };
  const totalCount = (summaries?.length ?? 0) + (adaptationSummaries?.length ?? 0);
  if (!totalCount) return null;
  return <div className="pr-1" data-sentry-component="SummaryStatus" data-sentry-source-file="SummaryStatus.tsx">
      <Badge count={totalCount} color={getTheme().antd.token?.colorPrimary || "blue"} offset={[-4, 4]} data-sentry-element="Badge" data-sentry-source-file="SummaryStatus.tsx">
        <Button shape="round" icon={icon} onClick={handleOpen} data-sentry-element="Button" data-sentry-source-file="SummaryStatus.tsx">
          {buttonText}
        </Button>
      </Badge>

      <SummaryStatusModal summaries={summaries} adaptationSummaries={adaptationSummaries} data-sentry-element="SummaryStatusModal" data-sentry-source-file="SummaryStatus.tsx" />
    </div>;
};